import * as React from 'react';

import { ProductTypeEditorView } from "./product-type-editor.view";

interface ProductTypeEditorControllerProps {
    value: number | null;
    mode: ControlMode;
    onChanged: (value: number | null) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	options?: any[];
}

export class ProductTypeEditorController extends React.Component<ProductTypeEditorControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <ProductTypeEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				options={this.props.options}
                required={this.props.required} onChanged={this.props.onChanged} value={this.props.value} mode={this.props.mode} label={this.props.label} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-type-editor.controller.tsx